import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.875.75C9.473.75 10 1.277 10 1.875v.703c2.566.492 4.5 2.777 4.5 5.485v.667c0 1.653.598 3.27 1.688 4.5l.246.282c.316.351.386.808.21 1.23-.175.387-.597.633-1.019.633h-13.5c-.457 0-.879-.246-1.055-.633a1.14 1.14 0 0 1 .211-1.23l.246-.282a6.84 6.84 0 0 0 1.723-4.5v-.668c0-2.707 1.934-4.992 4.5-5.484v-.703c0-.598.492-1.125 1.125-1.125m1.582 17.367c-.422.422-.984.633-1.582.633s-1.195-.21-1.617-.633c-.422-.422-.633-1.02-.633-1.617h4.5c0 .598-.246 1.195-.668 1.617" }, null, -1)
  ]))]))
}
export default { render: render }